const initialStateEntities = { 
  batteries: {},
  batteryLocations: {},
  videos: {},
  ambassadors: {},
  awards: {},
  selected: null,
}

export default initialStateEntities


// WEBPACK FOOTER //
// ./src/data/entities.js